/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import PlanCard from './PlanCard';
import { useUser } from '../../../hooks/user/useUser';
import SubPlanCard from './SubPlanCard';
import * as keys from '../../../services/config/Keys';

const Plans = () => {
  const [{ userPlans, isLoading }] = useUser();
  const [businessUnlimited, setBusinessUnlimited] = useState('');
  const [businessPRO, setBusinessPRO] = useState('');
  const [residentialPlan, setResidentialPlan] = useState(false);
  const [plan, setPlan] = useState({});

  useEffect(() => {
    userPlans.map((planData) => {
      return setPlan(planData);
    });
  }, [userPlans]);

  return (
    <div className="mt-2">
      <div className="text-center mb-1">
        <span className="sub_text font_22">Subscribe For Other Plans</span>
      </div>

      <div className="row justify-content-center align-items-center p-0">
        {isLoading ? (
          <small>loading...</small>
        ) : isEmpty(plan) ? (
          <>
            <SubPlanCard
              planName="Business Unlimited"
              monthlySub="350"
              checked={businessUnlimited}
              onChange={(e) => setBusinessUnlimited(e.target.checked)}
            />
            <SubPlanCard
              planName="Business PRO"
              monthlySub="400"
              checked={businessPRO}
              onChange={(e) => setBusinessPRO(e.target.checked)}
            />
            <SubPlanCard
              planName="Residential"
              monthlySub="300"
              checked={residentialPlan}
              onChange={(e) => setResidentialPlan(e.target.checked)}
            />
          </>
        ) : (
          <>
            <PlanCard
              planName="Business Unlimited"
              cost="350 per month"
              bonus="1 to 10 users"
              amount="350"
              image="images/house.png"
              checked={businessUnlimited}
              onChange={(e) => setBusinessUnlimited(e.target.checked)}
              interval=" monthly"
              paystackPlanCode={`${keys.PAYSTACK_200_PLAN_1_MONTH}`}
              ravePlanCode={`${keys.FLUTTERWAVE_200_PLAN_1_MONTH}`}
            />
            <PlanCard
              planName="Business PRO"
              cost="400 per month"
              bonus="11 to 20 users"
              amount="400"
              image="images/businessPro.png"
              checked={businessPRO}
              onChange={(e) => setBusinessPRO(e.target.checked)}
              interval=" monthly"
              paystackPlanCode={`${keys.PAYSTACK_250_PLAN_1_MONTH}`}
              ravePlanCode={`${keys.FLUTTERWAVE_250_PLAN_1_MONTH}`}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Plans;
